


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component({
    filters: {
        cut(value) {
            return `${value.substring(0, 65)}${value.length > 65 ? '...': ''}`
        }
    }
})
export default class News extends Vue {
    @Prop(String) title!: string
    @Prop(String) date!: string
    @Prop(Number) views!: number
    @Prop(String) img: string
    @Prop(Number) id: number

    get formDate() {
        return moment(this.date).format('DD.MM.YYYY');
    }
}

